var _jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/info-menu/Notifications.tsx",
  _this = this;
import React, { useEffect, useContext } from 'react';
import { StaticContext } from '../../../../StaticContext';
import { useInProductMessagesCountQuery } from './InProductMessagesCount.generated';
import NotificationsIcon from './NotificationsIcon';
import NotificationsSheet from './NotificationsSheet';
import HeaderContext from '../../HeaderContext';
var Notifications = function Notifications(_ref) {
  var _data$inProductMessag, _data$inProductMessag2;
  var showNotifications = _ref.showNotifications,
    toggleNotifications = _ref.toggleNotifications;
  var _useContext = useContext(StaticContext),
    _useContext$HEADER_EX = _useContext.HEADER_EXP,
    HEADER_EXP = _useContext$HEADER_EX === void 0 ? {} : _useContext$HEADER_EX;
  var pollInterval = HEADER_EXP.inProductMessagesPollingInterval || 0;
  var _useContext2 = useContext(HeaderContext),
    pageName = _useContext2.pageName,
    pageURL = _useContext2.pageURL;
  var _useInProductMessages = useInProductMessagesCountQuery({
      variables: {
        input: {
          isDeleted: false,
          isRead: false
        }
      },
      pollInterval: showNotifications ? 0 : pollInterval * 1000
    }),
    data = _useInProductMessages.data,
    refetch = _useInProductMessages.refetch;
  useEffect(function () {
    if (!showNotifications) {
      refetch();
    }
  }, [refetch, showNotifications]);
  var notificationsCount = (_data$inProductMessag = data === null || data === void 0 ? void 0 : (_data$inProductMessag2 = data.inProductMessagesCount) === null || _data$inProductMessag2 === void 0 ? void 0 : _data$inProductMessag2.totalCount) !== null && _data$inProductMessag !== void 0 ? _data$inProductMessag : 0;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NotificationsIcon, {
    unreadNotificationsCount: notificationsCount,
    toggleNotifications: toggleNotifications,
    showNotifications: showNotifications,
    pageName: pageName,
    pageURL: pageURL,
    refetchNotificationIconCount: refetch,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(NotificationsSheet, {
    unreadNotificationsCount: notificationsCount,
    toggleNotifications: toggleNotifications,
    showNotifications: showNotifications,
    pageName: pageName,
    pageURL: pageURL,
    refetchNotificationIconCount: refetch,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 7
    }
  }));
};
export default Notifications;
export { Notifications };
//# sourceMappingURL=Notifications.js.map